import React from 'react'
import { Navbar, Nav, Button } from 'react-bootstrap'
import { BiLinkExternal as ExternalLink } from 'react-icons/bi'
import { LinkContainer } from "react-router-bootstrap";
import { withRouter } from '../withRouter';

class ControllerNavBar extends React.Component {
    render() {
        const team = this.props.team || this.props.params.team;
        const user = this.props.user;
        const userLabel = user && (user.email || user.displayName || 'Signed in');
        return (
            <Navbar className="padded-nav-bar" collapseOnSelect bg="primary" variant="dark" expand="md" sticky="top" >
                <Navbar.Brand href={`/`}>Cruiser Console</Navbar.Brand>
                <Navbar.Toggle aria-controls="basic-navbar-nav" />
                <Navbar.Collapse id="basic-navbar-nav">
                    <Nav className="align-items-md-center">
                        <LinkContainer to={`/${team}/console/admin`} ><Nav.Link>Admin</Nav.Link></LinkContainer>
                        <LinkContainer to={`/${team}/console/control`} ><Nav.Link>Controller</Nav.Link></LinkContainer>
                        <Navbar.Text className="ms-md-3 py-2 py-md-0 d-md-none d-lg-inline-block">
                            Go to <a href={`/${team}`} target="_blank" rel="noopener noreferrer">Client <ExternalLink/></a> or <a href={`/${team}/display_board`} target="_blank" rel="noopener noreferrer">Display Board <ExternalLink /></a>
                        </Navbar.Text>
                    </Nav>
                    <Nav className="ms-md-auto align-items-md-center">
                        {userLabel && (
                            <Navbar.Text className="me-md-3 py-2 py-md-0 text-truncate controller-user-label">
                                Signed in as <strong>{userLabel}</strong>
                            </Navbar.Text>
                        )}
                        {this.props.signOut && (
                            <Button
                                size="sm"
                                variant="outline-light"
                                className="my-2 my-md-0 align-self-md-center align-self-start text-nowrap"
                                onClick={() => this.props.signOut()}
                            >
                                Sign out
                            </Button>
                        )}
                    </Nav>
                </Navbar.Collapse>
            </Navbar>
        );
    }
}

export default withRouter(ControllerNavBar);
